module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};


// WEBPACK FOOTER //
// ./packages/emdb/node_modules/core-js/library/modules/_fails.js